import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

interface Props {
  colSpan: number;
  label?: string;
  onRetry?: () => void;
}

// A table-body row that communicates a load failure (distinct from an empty
// result) and offers a retry. Use in the isError branch of a list table.
const ErrorRow: React.FC<Props> = ({
  colSpan,
  label = "Something went wrong while loading data",
  onRetry,
}) => {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-16 text-center">
        <div className="w-14 h-14 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-3">
          <AlertTriangle className="size-6 text-red-500" />
        </div>
        <p className="text-sm text-gray-600 mb-3">{label}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          >
            <RefreshCw className="size-4" /> Retry
          </button>
        )}
      </td>
    </tr>
  );
};

export default ErrorRow;
